module.exports = __webpack_public_path__ + "static/img/汤鹏辉.856bec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/汤鹏辉.jpg
// module id = Nrqb
// module chunks = 138